function clearPersistedPageState() {
  return localStorage.removeItem(window.location.pathname)
}

export default clearPersistedPageState
